export default function PHP_strncmp() {
  return (
    <div>
      <h1>PHP_strncmp</h1>
    </div>
  );
}
